import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import LoginForm from "../../components/auth/LoginForm";
import { dummyUsers } from "../../mock/dummyUsers";
import { accessMatrix as defaultMatrix } from "../../mock/accessMatrix";

const Login = ({ setIsLoggedIn }) => {
  const navigate = useNavigate();
  const emailRef = useRef(null);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    emailRef.current?.focus();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError("");

    const foundUser = dummyUsers.find(
      (user) => user.email === email && user.password === password
    );

    if (foundUser) {
      const token = "dummytoken-" + foundUser.id;

      // ✅ Ambil matrix dari localStorage (hasil update)
      const storedMatrix = JSON.parse(localStorage.getItem("accessMatrix"));
      const matrixToUse = storedMatrix || defaultMatrix;

      // ✅ Ambil role dan akses
      const role = foundUser.role;
      const access =
        role === "Super Admin"
          ? matrixToUse["Super Admin"].permissions
          : matrixToUse?.[role]?.permissions || {};

      // ✅ Simpan data auth ke localStorage
      const auth = {
        id: foundUser.id,
        name: foundUser.name,
        email: foundUser.email,
        role: foundUser.role,
        access,
      };

      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(foundUser));
      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("auth", JSON.stringify(auth));

      setIsLoggedIn(true);
      navigate("/dashboard");
    } else {
      setError("Email atau password salah.");
    }

    setIsSubmitting(false);
  };

  return (
    <div className="flex items-center justify-center min-h-screen px-4 bg-gradient-to-br from-green-100 to-green-300">
      <div className="w-full max-w-md p-8 bg-white shadow-2xl rounded-3xl animate-fade-in">
        <h2 className="mb-8 text-3xl font-bold text-center text-green-700">
          🌿 Sistem Koperasi
        </h2>

        <LoginForm
          email={email}
          password={password}
          showPassword={showPassword}
          isSubmitting={isSubmitting}
          error={error}
          emailRef={emailRef}
          setEmail={setEmail}
          setPassword={setPassword}
          setShowPassword={setShowPassword}
          handleSubmit={handleSubmit}
          navigate={navigate}
        />
      </div>
    </div>
  );
};

export default Login;
